import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2019 semantics GmbH
// Date        : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 161511 $
// Purpose     : tabbed components
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Tab, Segment } from 'semantic-ui-react';
import clsx from 'clsx';
// ---Framework imports
import { Actions } from 'uix/registries';
import { isNil } from 'ldash';
import { usePersistentShallow, useSelector, useActions, useEffect } from 'uix/hooks';
import styles from './tabs.css';
// ---Exports
let opts = {
    uiDefaults: {
        activeIndex: 0,
        activeKey: null,
        __version__: 1
    }
};
// part-local persistent Tab
export const XTab = ({ panes, className, menu = {
    tabular: true,
    compact: true
}, storeKey = 'Tab', syncRequestId = false, style })=>{
    /* a Tab with persistence
  custom pane props:
  - tabKey: store active tab via given key, instead of simple index (active if tabKeys for all panes given)
  - reqId: update browser url to this value (if syncRequestId=true)
  */ let [ui, setUI] = usePersistentShallow(storeKey, opts.uiDefaults);
    let replaceQueryParams = useActions(Actions.replaceQueryParams);
    let reqId = useSelector((root)=>root.meta.request.id);
    let activeIndex = ui.activeIndex;
    let tabKeys = panes.map((pane)=>pane.tabKey);
    let keyed = tabKeys.every((e)=>!isNil(e));
    if (keyed && ui.activeKey) {
        activeIndex = tabKeys.indexOf(ui.activeKey);
    }
    let onTabChange = (e, { activeIndex })=>{
        let nextOpts = {
            activeIndex
        };
        if (keyed) {
            nextOpts = {
                ...nextOpts,
                activeKey: tabKeys[activeIndex]
            };
        }
        setUI(nextOpts);
        if (syncRequestId) {
            replaceQueryParams({
                id: panes[activeIndex].reqId
            });
        }
    };
    useEffect(()=>{
        if (syncRequestId && reqId) {
            let idx = panes.findIndex((p)=>p.reqId == reqId);
            if (idx > -1) {
                setUI({
                    activeIndex: idx
                });
            }
        }
    }, [
        reqId
    ]);
    return /*#__PURE__*/ _jsx(Tab, {
        className: clsx(styles.tab, className),
        style: style,
        menu: menu,
        panes: panes,
        activeIndex: activeIndex,
        onTabChange: onTabChange
    });
};
XTab.segmentPane = (content)=>/*#__PURE__*/ _jsx(Tab.Pane, {
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        attached: false,
        children: /*#__PURE__*/ _jsx(Segment, {
            style: {
                display: 'flex',
                flexDirection: 'column'
            },
            children: content
        })
    });
XTab.pane = (content)=>/*#__PURE__*/ _jsx(Tab.Pane, {
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        attached: false,
        children: content
    });
XTab.simplePane = (content)=>/*#__PURE__*/ _jsx(Tab.Pane, {
        style: {
            marginTop: '0rem'
        },
        attached: false,
        children: content
    });
XTab.Pane = ({ flex = false, children, ...props })=>{
    let style = flex ? {
        display: 'flex',
        flexDirection: 'column'
    } : {};
    return /*#__PURE__*/ _jsx(Tab.Pane, {
        style: style,
        ...props,
        children: children
    });
};
